<template>
    <div class="delivery-address-section form" v-if="isOrderApplication && isDeliveryActive">
        <div>
            <DeliveryAddressButton :isInOperatorApp="props.isInOperatorApp" />
        </div>
    </div>
</template>

<script setup lang="ts">
    import { useCartStore } from "@/data/stores/cart";
    import { computed } from "vue";

    import DeliveryAddressButton from "@/components/pay/DeliveryAddress/DeliveryAddressButton.vue";

    const cart = useCartStore();

    // props
    const props = defineProps<{
        isInOperatorApp: boolean;
        onUpdateDeliveryAddress?: () => void;
    }>();

    const isOrderApplication = computed<boolean>(() => {
        return cart.orderService?.useCase != null;
    });

    const isDeliveryActive = computed<boolean>(() => {
        return cart.orderService?.useCase?.isDeliveryActive === true;
    });

    defineExpose({});
</script>

<style scoped lang="scss"></style>
